"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultGuardRepository = void 0;
const errors_1 = require("../errors");
class DefaultGuardRepository {
    constructor() {
        this.manifests = new Map();
    }
    add(...manifests) {
        manifests.forEach((manifest) => {
            if (manifest.serializer().fixedSize === null) {
                throw new errors_1.VariableSizeGuardError(manifest.name);
            }
            this.manifests.set(manifest.name, manifest);
        });
    }
    get(name) {
        const manifest = this.manifests.get(name);
        if (!manifest) {
            throw new errors_1.UnregisteredCandyGuardError(name);
        }
        return manifest;
    }
    all() {
        return Array.from(this.manifests.values());
    }
    forProgram(program) {
        return program.availableGuards.map((name) => this.get(name));
    }
}
exports.DefaultGuardRepository = DefaultGuardRepository;
//# sourceMappingURL=guardRepository.js.map